export default "__VITE_PUBLIC_ASSET__26553707__"